export enum draftEnum {
  oneshot = 'oneshot',
  certificate = 'certificate',
  cycle = 'cycle',
  exam = 'exam',
}
